import { Box, Heading, Tag } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Link } from '~/components/link';
import { SanityImage } from '~/components/sanity-image';
import { getKnowledgeAreaDisplayText } from '~/features/enterprise-resource/data';

import { CaseStudyRelatedCaseStudy } from '../models/case-study-content';

export function RelatedCaseStudiesSection({ relatedCaseStudies }: { relatedCaseStudies: CaseStudyRelatedCaseStudy[] }) {
  return (
    <Box as='section' display='flex' flexDirection={{ base: 'column', md: 'row' }} gap='32px'>
      {relatedCaseStudies.map((relatedCaseStudy) => (
        <Card
          key={relatedCaseStudy.title}
          background='accent.sky.100'
          borderRadius='8px'
          display='flex'
          flex={1}
          flexDirection='column'
          overflow='hidden'
          position='relative'
        >
          <Box
            alignItems='center'
            display='flex'
            justifyContent='center'
            minHeight='164px'
            position='relative'
            zIndex={1}
          >
            <Box
              background='linear-gradient(180deg, rgba(0, 1, 17, 0.9) 0%, rgba(23, 26, 83, 0.7) 100%);'
              height='100%'
              position='absolute'
              width='100%'
              zIndex={1}
            />

            <SanityImage
              image={relatedCaseStudy.company.lofiLogoLight}
              sizes='140px'
              style={{ width: '140px', zIndex: 2, position: 'relative' }}
            />

            {relatedCaseStudy.resourceCenterImage && (
              <SanityImage
                fill={true}
                image={relatedCaseStudy.resourceCenterImage}
                sizes='(min-width: 1280px) 25vw, (min-width: 992px) 33vw, (min-width: 768px) 50vw, 100vw'
                style={{ objectFit: 'cover', objectPosition: 'center', zIndex: '-1' }}
              />
            )}
          </Box>

          <Box padding='24px'>
            {relatedCaseStudy.knowledgeAreas?.[0] && (
              <Tag marginBottom='20px'>{getKnowledgeAreaDisplayText(relatedCaseStudy.knowledgeAreas[0])}</Tag>
            )}

            <Heading as='p' size='marketing-lg'>
              {relatedCaseStudy.title}
            </Heading>
          </Box>

          <Box marginTop='auto' padding='24px'>
            <Link
              _visited={{ color: 'blue.500' }}
              href={relatedCaseStudy.slug}
              textDecoration='none'
              width='fit-content'
              withArrow
            >
              View Case Study
            </Link>
          </Box>
        </Card>
      ))}
    </Box>
  );
}
